import { React, useState } from "react";
import { useTranslation } from "react-i18next";

import Header from "../containers/Header";
import MainLayout from "../layouts/MainLayout";
import Footer from "../containers/Footer";

import { Fade } from "react-awesome-reveal";

import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import {
  RiSendPlaneFill,
  RiWhatsappLine,
  RiMailLine,
  RiMapPinFill,
} from "react-icons/ri";

import { contactAPI } from "../apis";

function Contact() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [telephone, setTelephone] = useState("");
  const [description, setDescription] = useState("");
  const [contactByEmail, setContactByEmail] = useState("email");
  const [loading, SetLoading] = useState(false);

  const onSubmit = async () => {
    SetLoading(true);

    // Validate Phone number from stackoverflow
    var phoneregex = /^\+?([0-9][0-9]{3})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    // Validate Email from stackoverflow
    const emailregex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!telephone.match(phoneregex)) {
      toast.error("Numero de telephone incorrect");
      SetLoading(false);
    } else if (!email.match(emailregex)) {
      toast.error("Email incorrect");
    } else if (!email || !name || !description || !telephone) {
      toast.error("Aucun champ ne doit pas etre vide");
      SetLoading(false);
    } else {
      const json = await contactAPI({
        email,
        name,
        telephone,
        description,
        contact_by_email: contactByEmail === "email" ? true : false,
      });

      if (json) {
        toast(`Votre message a ete envoyer avec success!`, { type: "success" });
        setEmail("");
        setTelephone("");
        setName("");
        setDescription("");
        setContactByEmail("email");
      }
    }

    SetLoading(false);
    // auth.register(email, password, () => history("/insurrances"));
  };

  const { t } = useTranslation();

  return (
    <>
      <Header
        caption={"Contact"}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655461081/contact-header-img_fmlekh.svg"
        }
      />
      <MainLayout pageCSS="contact-page">
        <Row className="justify-content-center contact-form-container">
          <h2 className="u-pb-medium">Contact</h2>
          <Col lg={5} md={6}>
            <Card className="contact-form">
              <h3 className="text-center">
                <b>{t("contact_page_form_title")}</b>
              </h3>
              <Card.Body>
                <Form.Group className="u-mb-small">
                  <Form.Label>
                    {t("contact_page_form_input-label_name")}:
                  </Form.Label>
                  <Form.Control
                    label="Nom:"
                    type="text"
                    placeholder="Jean Martin Djomo"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="u-mb-small">
                  <Form.Label>
                    {t("contact_page_form_input-label_email")}:
                  </Form.Label>
                  <Form.Control
                    label="Email"
                    type="email"
                    placeholder="jmardjom362yahoo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="u-mb-small">
                  <Form.Label>
                    {t("contact_page_form_input-label_telephone")}:
                  </Form.Label>
                  <Form.Control
                    label="Numéro de téléphone:"
                    type="phone"
                    placeholder="+237675010203"
                    value={telephone}
                    onChange={(e) => setTelephone(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="u-mb-small">
                  <Form.Label>
                    {t("contact_page_form_input-label_description")}:
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("contact_page_form_how_to_contact_us")}
                  </Form.Label>
                  <br />
                  <Form.Check
                    inline
                    label="Email"
                    name="Email"
                    type="radio"
                    checked={contactByEmail === "email"}
                    onChange={(e) => setContactByEmail(e.target.value)}
                    value="email"
                    id={`email`}
                  />
                  <Form.Check
                    inline
                    label="Whatsapp"
                    name="Whatsapp"
                    checked={contactByEmail === "whatsapp"}
                    onChange={(e) => setContactByEmail(e.target.value)}
                    value="whatsapp"
                    type="radio"
                    id="whatsapp"
                  />
                </Form.Group>
                <Button
                  variant="blue"
                  className="contact-page-btn-submit u-mt-small btn-block"
                  onClick={onSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner
                      variant="standard"
                      as="span"
                      size="sm"
                      role="status"
                      animation="border"
                      aria-hidden="true"
                    />
                  ) : (
                    [
                      t("contact_page_form_submit_button"),
                      <RiSendPlaneFill key={2} size="20" />,
                    ]
                  )}
                </Button>
                <h3 className="text-center u-mt-medium">
                  <b>{t("contact_page_form_our_contacts")}</b>
                </h3>
                <div className="u-mt-medium">
                  <RiMapPinFill size="20" />
                  Douala, Deido Grand Poulin
                </div>
                <div className="u-mt-small">
                  <RiWhatsappLine size="20" />: +237 699 38 71 63
                </div>
                <div className="u-mt-small">
                  <RiMailLine size="20" />: Ako_assurance@yahoo.com
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={5} md={6}>
            <Fade triggerOnce>
              <Container className="contact-container">
                <h3 className="u-mb-medium">
                  {t("contact_page_how_we_can_help")}
                </h3>
                <h4>{t("contact_page_how_we_can_help_sub_text")}</h4>
                <img
                  src={
                    "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655461487/contact-letter-img_wqcuqf.png"
                  }
                  alt="ako contact-us"
                />
              </Container>
            </Fade>
          </Col>
          <ToastContainer containerId="an id" draggable={false} />
        </Row>
      </MainLayout>
      <Footer />
    </>
  );
}

export default Contact;
